var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-[5px] h-[5px] rounded-full required-indicator",class:_vm.filledClass})
}
var staticRenderFns = []

export { render, staticRenderFns }